import { getDB } from "../utils";

const STORE = "pianificazioni";

const toIsoDate = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    // Supporta stringhe "2025-12-23 00:00:00"
    const normalized = value.includes("T") ? value : value.replace(" ", "T");
    const parsed = new Date(normalized);
    if (Number.isNaN(parsed.getTime())) return null;
    return parsed.toISOString().slice(0, 10);
  }
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return value.toISOString().slice(0, 10);
  }
  return null;
};

const extractFascia = (oggetto = "") => {
  const parts = oggetto.split(",");
  return parts[1] ? parts[1].trim() : "";
};

export function normalizeTurnoRecord(userId, entry = {}) {
  if (!userId) throw new Error("Utente non valido per la cache turni");
  const dataRiferimento =
    toIsoDate(entry.data_riferimento) ||
    toIsoDate(entry.data_creazione) ||
    toIsoDate(new Date());
  return {
    id: entry.id ?? `turno_${Date.now()}_${Math.random().toString(16).slice(2)}`,
    user_id: userId,
    data_riferimento: dataRiferimento,
    data_creazione: entry.data_creazione || entry.data_riferimento || new Date().toISOString(),
    oggetto: entry.oggetto || "",
    testo: entry.testo || "",
    fascia_oraria: entry.fascia_oraria || extractFascia(entry.oggetto),
    fetched_at: entry.fetched_at || new Date().toISOString(),
  };
}

export async function upsertPianificazioni(userId, entries = []) {
  if (!userId || !Array.isArray(entries) || !entries.length) return;
  const db = await getDB();
  const tx = db.transaction(STORE, "readwrite");
  for (const raw of entries) {
    const record = normalizeTurnoRecord(userId, raw);
    await tx.store.put(record);
  }
  await tx.done;
}

export async function getPianificazioniForRange(userId, { dal, al } = {}) {
  if (!userId) return [];
  const db = await getDB();
  const records = await db.getAllFromIndex(STORE, "by_user", userId);
  return records
    .filter((rec) => {
      if (!rec?.data_riferimento) return false;
      if (dal && rec.data_riferimento < dal) return false;
      if (al && rec.data_riferimento > al) return false;
      return true;
    })
    .sort((a, b) => {
      const dateDiff = (b.data_riferimento || "").localeCompare(a.data_riferimento || "");
      if (dateDiff !== 0) return dateDiff;
      return (b.data_creazione || "").localeCompare(a.data_creazione || "");
    });
}

export async function getTurnoByDate(userId, date) {
  if (!userId || !date) return null;
  const db = await getDB();
  const matches = await db.getAllFromIndex(STORE, "by_user_date", [userId, date]);
  if (!matches.length) return null;
  return matches.sort((a, b) => (b.data_creazione || "").localeCompare(a.data_creazione || ""))[0];
}
